// extracted by mini-css-extract-plugin
module.exports = {"modIcon":"banner-telegram-bottom_modIcon__VCNFn","bannerMod":"banner-telegram-bottom_bannerMod__x3jU2"};